module.exports = __webpack_public_path__ + "assets/MARK_-_Good_Work.07e9c1ce.svg";